module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-2000-Classes-Active-cbb40893c651223463bb5d2746474cb1.png";